<template>
  <div class="flex flex-wrap">
      <div class="w-full lg:w-full px-4">
        <CardSettings :actions="actions" back-route="/admin/science"  />
      </div>
    </div>
</template>
<script>

import CardSettings from "@/components/Cards/CardSettings.vue";
import { API_BASE } from "@/const/uri";

export default {
  components: {
    CardSettings,
  },
  data() {
    return {
      actions: API_BASE.science.get,
    };
  }
};
</script>
